<template>
  <base-modal>
    <div class="content">
      <svg-vue
        style="width: 200px"
        icon="illustrations/review"
      />
      <h2>Want a quick review of your sitemap?</h2>
      <p>In just a few minutes, our trained AI tool will review your keywords you've assigned, and provide feedback.</p>
    </div>

    <div class="footer">
      <default-button
        size="md"
        fixed-width
        :disabled="processing"
        @click="startReview"
      >
        <template
          v-if="processing"
          #icon
        >
          <i class="fa fa-btn fa-spinner fa-spin" />
        </template>

        {{ processing ? 'Processing...' : 'Confirm' }}
      </default-button>
    </div>
  </base-modal>
</template>

<script>
import {mapActions} from "vuex";
import BaseModal from "../../global/modals/BaseModal.vue";
import DefaultButton from "../../global/buttons/DefaultButton.vue";

export default {
  components: {DefaultButton, BaseModal},
  data() {
    return {
      processing: false,
    }
  },
  methods: {
    ...mapActions('strategy', [
      'reviewSitemapKeywords',
    ]),
    async startReview() {
      if (this.processing) {
        return;
      }

      this.processing = true;
      await this.reviewSitemapKeywords()
      this.processing = false;
    },
  }
}
</script>


<style lang="scss" scoped>
.content {
  width: 500px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 0 auto;
  text-align: center;
  align-items: center;
  padding: 10px 0 55px;

  h2 {
    font-size: 32px;
    font-weight: 500;
    margin: 15px 0 0;
  }

  p {
    margin: 10px 0 0;
    font-size: 16px;
  }
}

.footer {
  display: flex;
  justify-content: flex-end;
}
</style>
